import { Button, Grid, Typography } from '@mui/material';
import { deDE, GridColDef } from '@mui/x-data-grid';
import { IPersonalPropertyAsset } from '../../../../../../Interfaces/Asset/AssetCategoryTypes';
import { IAsset } from '../../../../../../Interfaces/Asset/IAsset';
import { IAssetCategoryId } from '../../../../../../Interfaces/Asset/IAssetCategory';
import { IAssetTypeId } from '../../../../../../Interfaces/Asset/IAssetType';
import { CrudDataGrid } from '../../../generic/CrudDataGrid';

type PersonalPropertyAssetsSectionProps = {
  assets: IPersonalPropertyAsset[];
  handleOpen: (
    assetCategoryId: IAssetCategoryId,
    assetTypeId?: IAssetTypeId,
    assetId?: number
  ) => void;
  handleDelete: (assetId: number) => void;
};

function getAssetValue(asset: IAsset): number {
  switch (asset.idAssetType) {
    case IAssetTypeId.Depot:
      return asset.data.value || 0;
    case IAssetTypeId.Cash:
      return asset.data.amount || 0;
    case IAssetTypeId.BankAccount:
      return asset.data.balance || 0;
    default:
      return 0;
  }
}

const columns: GridColDef<IPersonalPropertyAsset, any, any>[] = [
  { field: 'name', headerName: 'Name', width: 150 },
  {
    field: 'value',
    headerName: 'Wert (€)',
    valueGetter: params => getAssetValue(params.row),
    valueFormatter: params => {
      const value = params.value as number;
      return value.toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR',
      });
    },
    flex: 1,
  },
];

export function PersonalPropertyAssetsSection({
  assets,
  handleOpen,
  handleDelete,
}: PersonalPropertyAssetsSectionProps) {
  const personalPropertyAssets = assets.filter(
    asset => asset.idAssetCategory === IAssetCategoryId.PersonalProperty
  );
  return (
    <>
      <Grid item xs={6}>
        <Typography variant='h4' sx={{ mb: 3 }}>
          Finanzvermögen
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Button
          sx={{ float: 'right' }}
          variant='contained'
          onClick={() => handleOpen(IAssetCategoryId.PersonalProperty)}
        >
          Geldwerte hinzufügen
        </Button>
      </Grid>

      <Grid item xs={12}>
        <CrudDataGrid<IPersonalPropertyAsset>
          sx={{ mt: 2 }}
          autoHeight
          localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
          rows={personalPropertyAssets}
          columns={columns}
          getRowId={row => row.idAsset}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
          }}
          pageSizeOptions={[5]}
          disableRowSelectionOnClick
          onClickEdit={(assetId, assetRow) => {
            handleOpen(
              IAssetCategoryId.PersonalProperty,
              assetRow.idAssetType,
              Number(assetId)
            );
          }}
          onClickDelete={assetId => {
            handleDelete(Number(assetId));
          }}
        />
      </Grid>
    </>
  );
}
